import { defineComponent as _defineComponent } from 'vue'
import CreateAccountPage from './CreateAccountPage.vue';
import EnterPhonePage from './EnterPhonePage.vue';
import ForgotPasswordPage from './ForgotPasswordPage.vue';
import SelectAccountPage from './SelectAccountPage.vue';
import SignInPage from './SignInPage.vue';
import { CreateOauthAccountRequest, ICreateAccountResource, ICreateAccountResponse, LoginPageType } from 'JS/types/Account';
import { delay } from 'JS/utilities/promise';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { objectToQueryString } from 'JS/utilities/url';
import { onMounted, ref } from 'vue';
import { provideDefaultInputLabelVariant } from 'JS/components/blain-form/input-label-variant';
import { serviceRegistry } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginSideMenuContents',
  props: {
    page: null,
    skipCartMerge: { type: Boolean },
    isFullScreenVersion: { type: Boolean },
    createAccountRequest: null,
    createAccountResponse: null,
    createOauthAccountRequest: null
  },
  emits: ["go-to-rewards", "go-to-rewards-with-oauth", "loading", "update-side-menu-header-button", "update:page", "signed-in", "update:createAccountRequest", "update:createAccountResponse", "update:createOauthAccountRequest"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'go-to-rewards', page: IJoinRewardsStep, data?: IVerifyUserData, createAccountRequest?: ICreateAccountResource, returnPage?: LoginPageType): void;
	(event: 'go-to-rewards-with-oauth', page: IJoinRewardsStep, data?: IVerifyUserData, createOauthAccountRequest?: CreateOauthAccountRequest, returnPage?: LoginPageType): void;
	(event: 'loading', value: boolean): void;
	(event: 'update-side-menu-header-button', returnPage: LoginPageType | 'clear'): void
	(event: 'update:page', value: string)
	(event: 'signed-in'): void;
	(event: 'update:createAccountRequest', createAccountRequest: ICreateAccountResource): void;
	(event: 'update:createAccountResponse', createAccountResponse: ICreateAccountResponse): void;
	(event: 'update:createOauthAccountRequest', createOauthAccountRequest: CreateOauthAccountRequest): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	page: LoginPageType,
	skipCartMerge?: boolean,
	isFullScreenVersion?: boolean,
	createAccountRequest?: ICreateAccountResource,
	createAccountResponse?: ICreateAccountResponse,
	createOauthAccountRequest?: CreateOauthAccountRequest
}

//Imports




const { getAntiForgeryToken } = serviceRegistry;
provideDefaultInputLabelVariant('inline');

const showCaptcha = ref<boolean>(false);
const currentEmail = ref<string>('');
const antiForgeryToken = ref<string>('');

function changePage(page: LoginPageType, returnPage?: LoginPageType) {
	let retPage: LoginPageType | 'clear' = 'clear';

	switch (page) {
		case 'select-account':
			retPage = 'create';
			break;
		case 'forgot-password':
			retPage = 'login';
			break;
		case 'enter-phone':
			retPage = returnPage;
			break;
	}

	emit('update-side-menu-header-button', retPage);
	emit('update:page', page);
}

function handleSignedIn() {
	window?.vueEventBus?.$emit('blain-login-success');
	emit('signed-in');
}

function handleGoToSelectAccount(response: ICreateAccountResponse, request: ICreateAccountResource) {
	emit('update:createAccountRequest', request);
	emit('update:createAccountResponse', response);
	changePage('select-account');
}

function handleGoToEnterPhone(createOauthAccountRequest: CreateOauthAccountRequest, returnPage: LoginPageType) {

	emit('update:createOauthAccountRequest', createOauthAccountRequest);
	changePage('enter-phone', returnPage);
}

onMounted(async ()=> {
	emit('loading', true);
	antiForgeryToken.value = await delay(getAntiForgeryToken(), 400);
	if (!window.location.pathname.includes('login') && !antiForgeryToken.value) {
		window.location.href = `/account/login/?${objectToQueryString({
			refUrl: window?.location.pathname,
			create: props.page === 'create' ? '1' : '0'
		})}`;
	} else {
		emit('loading', false);
	}
});


return { __sfc: true,props, emit, getAntiForgeryToken, showCaptcha, currentEmail, antiForgeryToken, changePage, handleSignedIn, handleGoToSelectAccount, handleGoToEnterPhone, CreateAccountPage, EnterPhonePage, ForgotPasswordPage, SelectAccountPage, SignInPage }
}

})